


































import { Component, Vue, Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

import { localize, extend } from "vee-validate";
import { email, numeric } from "vee-validate/dist/rules";

@Component({
  components: {
    ValidationProvider
  },
  name: "TextInput"
})
export default class TextInput extends Vue {
  @Prop({ required: false, default: undefined }) vid!: string;
  @Prop({ required: true, default: "" }) name!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: false }) hideLabel!: boolean;
  @Prop({ required: false, default: "" }) rules!: string | object;
  @Prop({ required: false, default: null }) placeholder!: string | null;
  @Prop({ required: false, default: null }) classes!: string | null;
  @Prop({ required: false, default: null }) note!: string | null;
  @Prop({
    required: false,
    default: "text",
    validator(value) {
      return [
        "url",
        "text",
        "password",
        "tel",
        "search",
        "number",
        "email"
      ].includes(value);
    }
  })
  type!: string;

  @Prop({ required: true, default: "" }) value!: string;

  get innerValue(): string {
    return this.value;
  }

  set innerValue(value: string) {
    this.$emit("input", value);
  }

  setupValidation(): void {
    // Make sure we pull in the appropriate validation rules
    const prefix = 'https://www.instagram.com/';
    switch (this.type) {      
      case "url2":
        extend("url", {          
          validate: value => {
            const re = /(https?:\/\/[^\s]+)/g;
            return re.test(value);
          },                  
          message: "Please enter a valid url begining with http:// or https:// for {_field_}"
        });  
        extend("instagramurl", {
          validate: value => {
            const re = /^(?!.*\.\.)(?!.*__)(?!.*[A-Z])(?!.*\.$)[^\W][\w.]{0,29}$/gm;
            let valueToValidate = value;
            const lastChar = value.charAt(value.length - 1);            
            if (lastChar == '/'){
              valueToValidate = value.slice(0,-1);
            }            
            return value != null && value.startsWith(prefix) && re.test(valueToValidate.replace(prefix,''));
          },                  
          message: "Instagram url is not valid. Please enter the full URL beginning with " + prefix
        });        
        break;
      case "email":
        extend("email", email);
        break;
      case "number":
        extend("numeric", numeric);
        break;
    }

    // Validation custom messages - localise the names.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const names: any = {};

    names[this.name] = this.label || this.name;

    localize({
      en: {
        names
      }
    });
  }
  created(): void {
    this.setupValidation();
  }
}
